import React from 'react';
import { List, Typography, Checkbox, Space } from 'antd';
import { scaleIngredientAmount, formatFraction } from '../../../helpers/recipeCalculations';

const { Text } = Typography;

const IngredientList = ({ ingredients, baseServings, currentServings }) => {
  if (!ingredients || ingredients.length === 0) {
    return <Text type="secondary">No ingredients listed.</Text>;
  }

  return (
    <List
      dataSource={ingredients}
      renderItem={(ingredient) => {
        const scaledAmount = scaleIngredientAmount(
          ingredient.amount,
          baseServings,
          currentServings
        );
        const displayAmount = formatFraction(scaledAmount);

        return (
          <List.Item style={{ padding: '8px 0', border: 'none' }}>
            <Space align="start">
              <Checkbox style={{ marginTop: '4px' }} />
              <Text>
                <Text strong>{ingredient.name}</Text>
                {' - '}
                {displayAmount} {ingredient.unitOfMeasureAbbreviation || ingredient.unitOfMeasure}
              </Text>
            </Space>
          </List.Item>
        );
      }}
    />
  );
};

export default IngredientList;
